/**
 * One sentence instead of four counter tiles.
 *
 * It says the same things the tiles did and takes a line rather than a block —
 * and unlike a tile it can say nothing at all when there is nothing to say,
 * which "0 blocked" never could.
 */
export function summary(total: number, overdue: number, blocked: number): string {
  if (total === 0) return "Nothing is sitting with you right now.";

  // "You have five items assigned to you." (punch list F103, 30 Oct 2026),
  // which replaced "5 things are with you.": one to nine are words, 10 and
  // over are digits, as house style writes numbers in prose.
  const head = `You have ${countWord(total)} ${total === 1 ? "item" : "items"} assigned to you.`;
  const parts: string[] = [];
  if (overdue > 0) parts.push(`${countWord(overdue)} ${overdue === 1 ? "is" : "are"} late`);
  if (blocked > 0) parts.push(`${countWord(blocked)} ${blocked === 1 ? "is" : "are"} blocked`);
  if (parts.length === 0) return `${head} Nothing is late or blocked.`;
  const tail = parts.join(" and ");
  return `${head} ${tail[0]!.toUpperCase()}${tail.slice(1)}.`;
}

const COUNT_WORDS = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine"];

/** A count as prose writes it: a word below ten, digits from 10. */
export function countWord(n: number): string {
  return Number.isInteger(n) && n >= 0 && n < 10 ? COUNT_WORDS[n]! : String(n);
}
